import { iconMapping } from "~/icons/old-new-icon-mapping.json";
import { iconMappingFree } from "~/icons/old-new-icon-mapping-free.json";
import { iconFallback } from "~/icons/icon-fallback-mapping.json";

const checkFontFamily = "Font Awesome 6 Pro";
const checkFontWeightLight = 300;
const checkFontWeightRegular = 400;
let loaded = false;
let proIconFound = false;
let proIconChecked = false;

export async function hasProIcon(): Promise<boolean> {
  if (!loaded) {
    await checkProIcon();
  }

  return proIconFound;
}

/**
 * Provides a fallback icon from 'Font Awesome 6 Free'
 */
export async function getIconName(icon: string): Promise<string> {
  const iconMeta = icon.replace("fa-", "");
  if (!loaded) {
    await checkProIcon();
  }

  if (!proIconFound && iconMeta) {
    const mapping = (iconFallback as { [key: string]: string })?.[iconMeta];
    return mapping ? `fa-${mapping}` : "";
  }

  return icon;
}

export async function getNewIconName(icon: string): Promise<string> {
  if (!loaded) {
    await checkProIcon();
  }

  if (proIconFound) {
    return (iconMapping as { [key: string]: string })?.[icon] || "";
  }

  return (iconMappingFree as { [key: string]: string })?.[icon] || "";
}

async function checkProIcon(): Promise<void> {
  if (proIconChecked) {
    loaded = true;
    return;
  }

  if (typeof document === "undefined" || !document.fonts) {
    proIconFound = false;
    loaded = true;
    return;
  }

  const fontFaceSet = await document.fonts.ready;
  const fontFaces: FontFace[] = [];
  fontFaceSet.forEach((fontFace) => {
    fontFaces.push(fontFace);
  });

  proIconFound = fontFaces.some(
    (fontFace) =>
      fontFace.family.replace(/['"]/g, "") === checkFontFamily &&
      (fontFace.weight.toString() === checkFontWeightLight.toString() ||
        fontFace.weight.toString() === checkFontWeightRegular.toString()) &&
      fontFace.status === "loaded"
  );

  loaded = true;
}

// Unit test helper only. Do not use in production code.
export function setProIconFound(found: boolean): void {
  proIconFound = found;
  loaded = true;
  proIconChecked = true;
}

// Unit test helper only. Do not use in production code.
export function resetProIconCheck(): void {
  loaded = false;
  proIconFound = false;
  proIconChecked = false;
}
